import base from './routes/base.js'
import face from './routes/face.js'
import order from './routes/order.js'
import member from './routes/member.js'
import popup from './routes/popup.js';
import timeOff from './routes/time-off.js';

// const Home = () => import( /*webpackChunkName: "Home"*/ '@simple/views/home/home.vue')

let routes = [{
    path: '/',
    redirect: '/home/0'
}, {
    path: '/home',
    redirect: '/home/0'
}, {
    path: '/home/:active',
    name: 'home',
    component: () => import("@parent/views/home/home.vue"),
    meta: {
        vx_exclude_params: ['active']
    }
}, {
    path: '/stop-xcx',
    name: 'stop-xcx',
    component: () => import("@parent/stop-xcx.vue"),
}, ]

const router = new VueRouter({
    routes: [
        ...routes,
        ...base,
        ...face,
        ...order,
        ...member,
        ...popup,
        ...timeOff,
    ]
})


/** 添加 Google 分析 start */
// 路由页面统计
router.afterEach((to, from) => {
    // console.log("路由变化,,, ");
    // console.log(to);
    setTimeout(()=>{
        gtag('event', 'x3-event-page', {
            x3_env: process.env.VUE_APP_x3_env,
            x3_app_type: "x3-mobile-家长端",
            x3_client_type: app.base.env,
            // x3_company_name: app.teacher.user.companyInfoVo.companyName,
            x3_page_name: to.name,
            x3_page_alias: document.title,
            x3_page_path: to.path,
        })
    }, 301)
    
});
/** 添加 Google 分析 end */

export default router;